import apiCalls from "../../config/apiCalls";
import Headers from "../../config/headers";
import { keyMapsMutation } from "../../helpers/storeKeys";

export default {
  namespaced: true,
  state: {
    favouriteData: [],
  },
  getters: {},
  mutations: {
    updateFavouriteData(state, payload) {
      state.favouriteData = payload;
    },
  },
  actions: {
    getFavouriteData({ commit }, payload) {
      commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
        root: true,
      });
      apiCalls
        .FAVOURITE_DATA_API({
          headers: { ...Headers() },
        })
        .then(function (response) {
          if (
            response?.data?.productDefinitions ||
            response?.data?.comboDefinitions
          ) {
            commit("updateFavouriteData", response?.data);
          }
          if (response?.data?.mediaBaseURL) {
            commit(
              keyMapsMutation.UPDATE_IMG_BASE_URL,
              response?.data?.mediaBaseURL,
              {
                root: true,
              }
            );
          }
          commit(keyMapsMutation.UPDATE_PRODUCTS_IN_STORE, response?.data, {
            root: true,
          });
          commit(
            keyMapsMutation.LOAD_CART_FROM_STORAGE_SERVICE,
            response?.data,
            {
              root: true,
            }
          );
          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
        })
        .catch(function (error) {
          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
        });
    },
  },
};
